// src/features/criador/CodigoCriadorPagina.jsx
//
// Rota /codigo-criador — entre o código do WhatsApp de um cadastro novo e
// /bem-vindo (VerificacaoCode manda para cá com o mesmo state).
//
// Aparece só com a flag CRIADORES_ATIVO ligada. Desligada (ou se a flag não
// carrega em 2,5 s), segue direto para /bem-vindo: o cadastro nunca espera
// o programa.

import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { auth } from "../../firebaseConfig";
import CodigoCriadorEtapa from "./CodigoCriadorEtapa";
import { lerCupomGuardado } from "./cupomCriador";
import { carregarPrograma } from "./usePrograma";

export default function CodigoCriadorPagina() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [mostrar, setMostrar] = useState(false);
  const decidido = useRef(false);

  const seguir = useCallback(() => {
    decidido.current = true;
    navigate("/bem-vindo", { state: state || {}, replace: true });
  }, [navigate, state]);

  useEffect(() => {
    let vivo = true;
    if (!auth.currentUser) {
      seguir();
      return undefined;
    }
    const limite = setTimeout(() => { if (vivo && !decidido.current) seguir(); }, 2500);
    carregarPrograma().then((p) => {
      if (!vivo || decidido.current) return;
      clearTimeout(limite);
      if (p?.CRIADORES_ATIVO === true) {
        decidido.current = true;
        setMostrar(true);
      } else {
        seguir();
      }
    });
    return () => { vivo = false; clearTimeout(limite); };
  }, [seguir]);

  if (!mostrar) return null;
  return (
    <CodigoCriadorEtapa
      user={auth.currentUser}
      codigoInicial={lerCupomGuardado()?.codigo || ""}
      onConcluir={seguir}
    />
  );
}
